import {DARK_MAP_STYLE} from '../shared/google-map-styles.js';
import {overviewRegion} from './tracker-map-model.ts';
export const MAP_STYLES=['current','road','satellite'] as const;
export type MapStyle=typeof MAP_STYLES[number];
export function effectiveMapStyle(style:MapStyle,satellite=true):MapStyle{return !satellite&&style==='satellite'?'road':style;}
export function nextMapStyle(style:MapStyle,satellite=true):MapStyle{
 const available:readonly MapStyle[]=satellite?MAP_STYLES:MAP_STYLES.filter(v=>v!=='satellite');
 return available[(available.indexOf(effectiveMapStyle(style,satellite))+1)%available.length];
}
export type MapRegion={latitude:number;longitude:number;latitudeDelta:number;longitudeDelta:number};
export function validMapStyle(value:unknown):value is MapStyle{return MAP_STYLES.includes(value as MapStyle);}
export function mapPresentation(style:MapStyle){
 return {customMapStyle:style==='current'?DARK_MAP_STYLE:[],mapType:style==='satellite'?'satellite' as const:'standard' as const,userInterfaceStyle:style==='current'?'dark' as const:'light' as const};
}
const MIN_DELTA=.0001,MAX_LAT_DELTA=170,MAX_LNG_DELTA=350;
// Android converts a region to LatLngBounds before moving the camera. Limiting
// only the span is insufficient: 56 N + half of 170 degrees crosses the pole.
// Keep both edges inside Google's Mercator map, moving the viewport towards
// the equator as it widens. This changes the camera, never tracker coordinates.
export function safeMapRegion(region:MapRegion):MapRegion{
 if(!Object.values(region).every(Number.isFinite)||region.latitudeDelta<=0||region.longitudeDelta===0)return {...overviewRegion};
 // Android reports east minus west; a date-line crossing can be negative.
 const lngSpan=region.longitudeDelta<0&&region.longitudeDelta>-360?region.longitudeDelta+360:region.longitudeDelta;
 if(lngSpan<=0)return {...overviewRegion};
 const latitudeDelta=Math.max(MIN_DELTA,Math.min(MAX_LAT_DELTA,region.latitudeDelta));
 const longitudeDelta=Math.max(MIN_DELTA,Math.min(MAX_LNG_DELTA,lngSpan));
 const latitudeLimit=85-latitudeDelta/2;
 return {latitude:Math.max(-latitudeLimit,Math.min(latitudeLimit,region.latitude)),
  longitude:Math.abs(region.longitude)<=180?region.longitude:((region.longitude%360)+540)%360-180,
  latitudeDelta,longitudeDelta};
}
